fragment DocumentPaymentMetadata on Document {
  id
  paymentMetadata {
    iban
    amount
    recipient
    reference
  }
}
